/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-11-11T09:27:30.356
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listReportFinancialStorageContractPlan,
	listReportFinancialStorageContractPlanInit,
	listReportFinancialStorageContractPlanByAuthorizations,
	deleteReportFinancialStorageContractPlan
	
} from '@api/report/ReportFinancialStorageContractPlan';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listReportFinancialStorageContractPlan({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialStorageContractPlan(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportFinancialStorageContractPlanByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialStorageContractPlanByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportFinancialStorageContractPlanInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportFinancialStorageContractPlanInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteReportFinancialStorageContractPlan({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportFinancialStorageContractPlan({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
